import script from "./SigPr.vue?vue&type=script&setup=true&lang=js"
export * from "./SigPr.vue?vue&type=script&setup=true&lang=js"

import "./SigPr.vue?vue&type=style&index=0&id=4b3e5a95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3e5a95"]])

export default __exports__